import React, {useCallback, useEffect, useState} from 'react';
import {useNavigate} from 'react-router-dom';
import {api} from './Api.js';
import VocabularyStats from './VocabularyStats';
import GrammarStats from './GrammarStats';
import SummaryCard from './SummaryCard';

const Statistics = ({showNotification, externalData, hideSummary = false}) => {
  const [summary, setSummary] = useState(externalData || null);
  const [loading, setLoading] = useState(!externalData);
  const navigate = useNavigate();
  const fetchAllStatistics = useCallback(async () => {
    if (externalData) return;
    setLoading(true);
    const response = await api.fetchSummaryStatistics(navigate, showNotification);
    if (api.isValidResponse(response)) setSummary(response.data);
    setLoading(false);
  }, [externalData, navigate, showNotification]);
  useEffect(() => {
    if (externalData) {
      setSummary(externalData);
      setLoading(false);
    } else fetchAllStatistics();
  }, [externalData, fetchAllStatistics]);
  if (loading) return <div className="page-loader"><span className="loader-dot"/> Loading your progress…</div>;
  const writing = summary?.writing;
  return <section className="statistics-view" aria-label="Learning statistics">
    {!hideSummary && <SummaryCard summary={summary}/>}
    <div className="statistics-grid"><VocabularyStats vocabulary={summary?.vocabulary}/>
      <div><GrammarStats grammar={summary?.grammar}/>
        <section className="stats-card surface-card writing-stats">
          <div className="stats-card__heading"><span className="stats-card__icon stats-card__icon--violet"><i className="material-icons" aria-hidden="true">edit_note</i></span>
            <div><h2>Writing</h2><p>Practice in context with focused AI feedback.</p></div>
          </div>
          <div className="metric-grid metric-grid--three">
            <div className="metric-item"><i className="material-icons" aria-hidden="true">chat_bubble_outline</i><strong>{writing?.totalMessagesSent || 0}</strong><span>Messages</span></div>
            <div className="metric-item"><i className="material-icons" aria-hidden="true">star_outline</i><strong>{Number(writing?.averageRating || 0).toFixed(1)}</strong><span>Average score</span>
            </div>
            <div className="metric-item"><i className="material-icons" aria-hidden="true">theater_comedy</i><strong>{writing?.uniqueRolesCount || 0}</strong><span>Scenarios</span></div>
          </div>
        </section>
      </div>
    </div>
  </section>;
};
export default Statistics;
